import React from 'react';

import { TemplatesProvider } from 'Templates';
import {
  ScreenAllFilters,
  ScreenFilters,
  ScreenFiltersApply,
} from 'components/Filters';
import { ScreenPresets } from 'components/Presets';

import { Route } from '@gogame/screens';
import { Sentry } from '@gogame/components';
import { Screen, withScreen, createScreenRoute } from '@gogame/screens';

import AllFilters from './components/Filters/AllFilters';
import PrimaryFilters from './components/Filters/PrimaryFilters';
import { MasterCampaignsDataTable } from './components/MasterCampaignsDataTable';
import { MasterCampaignRouteElement } from './components/MasterCampaignDetails';
import {
  masterCampaignsLink,
  masterCampaignsSearchParams,
  masterCampaignsDetailsLink,
} from './navigation';
import { EMPTY_FILTERS, mapStateToPreset } from './schemas';
import screenReducer from './screenReducer';

const id = 1059;
const permission = 72;

const MasterCampaigns = withScreen({
  name: 'master-campaigns',
  searchParams: masterCampaignsSearchParams,
  reducer: screenReducer,
})(() => {
  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <ScreenPresets mapStateToPreset={mapStateToPreset} />
        <ScreenFilters emptyValues={EMPTY_FILTERS}>
          <PrimaryFilters />
          <ScreenAllFilters sidePage={AllFilters} />
          <ScreenFiltersApply />
        </ScreenFilters>
        <MasterCampaignsDataTable />
        <Sentry.Routes>
          <Route
            path={masterCampaignsDetailsLink.path}
            element={<MasterCampaignRouteElement />}
          />
        </Sentry.Routes>
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  title: 'Master Campaigns',
  link: masterCampaignsLink,
  screen: (
    <TemplatesProvider serverPageId={id}>
      <MasterCampaigns />
    </TemplatesProvider>
  ),
  id: id,
  permission: permission,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/articles/360015102480-Master-Campaigns',
});
